import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { PendenciaPedido } from 'src/app/models/pendenciapedido';
import { Pendencia } from 'src/app/models/pendencia';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PendenciaService } from 'src/app/services/pendencia.service';

@Component({
  selector: 'app-cadastrar-pendencia-modal',
  templateUrl: './cadastrar-pendencia-modal.component.html',
  styleUrls: ['./cadastrar-pendencia-modal.component.scss']
})
export class CadastrarPendenciaModalComponent implements OnInit {

  pendenciasDoPedido: PendenciaPedido[];
  idCupom: string;
  pendencias: Pendencia[] = [];
  cadastro: boolean = true;
  pendenciasConcluidas: boolean[] = [];
  pendenciasSelecionadas: number[] = [];
  pendenciasSelecionadasCadastro: number[] = [];
  possuiPendencias = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<CadastrarPendenciaModalComponent>,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private pedidoService: PedidoService,
    private pendenciaService: PendenciaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    if(this.data) {
      this.idCupom = this.data.idCupom;
      this.cadastro = this.data.cadastro;
      this.possuiPendencias = this.data.possuiPendencias;
    }
  }

  async ngOnInit() {
    await this.buscarPendenciasPedido();
    await this.buscarPendencias();
  }

  buscarPendenciasPedido() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarPendenciasPedido');
      this.pendenciaService.consultarPorIdCupom(this.idCupom).subscribe(
        pendenciasPedido => {
          this.pendenciasDoPedido = pendenciasPedido;

          this.pendenciasSelecionadas =
            this.pendenciasDoPedido
              .filter(p => p.dataConclusao != null)
              .map(p => p.id);

          this.changeDetectorRef.detectChanges();

          this.carregandoService.esconde('buscarPendenciasPedido');
          resolve();
        },
        err => {
          this.carregandoService.esconde('buscarPendenciasPedido');
          this.notificacaoService.erro(err);
          reject(err);
        }
      );
    });
  }

  buscarPendencias() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarPendencias');
      this.pendenciaService.consultarPendencias().subscribe(
        pendencias => {
          this.pendencias = this.cadastro ? pendencias :
            pendencias.filter(p => this.pendenciasDoPedido
              .map(p => p.pendenciaId)
              .includes(p.id)
            );

          if(this.pendencias.length == 0) {
            this.dialogRef.close({resolvido: true, pendencias: [{}]});
          }

          this.carregandoService.esconde('buscarPendencias');
          resolve();
        },
        err => {
          this.carregandoService.esconde('buscarPendencias');
          this.notificacaoService.erro(err);
          reject(err);
        }
      );
    });
  }

  removerPendencia(pendencia: Pendencia) {
    this.pendenciasDoPedido = this.pendenciasDoPedido.filter(p => p.pendenciaId !== pendencia.id);
  }

  salvar(resolvido: boolean = false) {
    let pendenciasDoPedido = [];
    if (this.cadastro) {
      pendenciasDoPedido = this.pendenciasSelecionadasCadastro.map(pendenciaid => {
        return {
          pendenciaid,
          idcupom: this.idCupom,
          concluido: false
        };
      });
    } else {
      pendenciasDoPedido = this.pendenciasDoPedido.map(pendencia => {
        return {
          id: pendencia.id,
          pendenciaid: pendencia.pendenciaId,
          idcupom: this.idCupom,
          funcionarioID: pendencia.funcionarioID,
          funcionarioIDConclusao: pendencia.funcionarioIDConclusao,
          concluido: this.pendenciasSelecionadas.includes(pendencia.id),
          dataCriacao: pendencia.dataCriacao,
          dataConclusao: pendencia.dataConclusao
        };
      });
    }

    this.carregandoService.mostra('salvar');

    this.pedidoService.salvarPendencias(this.idCupom, pendenciasDoPedido).subscribe(
      () => {
        this.carregandoService.esconde('salvar');

        if(!this.cadastro) {
          this.notificacaoService.sucesso('Pendencias salvas com sucesso!!!');
        }

        this.dialogRef.close({resolvido, pendencias: pendenciasDoPedido});
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  aoSelecionarPendencia(pendencia, event) {
    if (event.target.checked) {
      this.pendenciasSelecionadas = this.pendenciasSelecionadas.concat([pendencia.id]);
    } else {
      const index = this.pendenciasSelecionadas.indexOf(pendencia.id);
      if (index >= 0) {
        this.pendenciasSelecionadas.splice(index, 1);
      }
    }
  }

  isChecked(pendenciaId: number): boolean {
    return this.pendenciasSelecionadas.some(p => p === pendenciaId);
  }

  isAllChecked(): boolean {
    return !this.cadastro && this.pendenciasSelecionadas.length === this.pendenciasDoPedido.length;
  }

  fechar() {
    this.dialogRef.close();
  }
}
